import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Reveal } from "./Reveal";
import { Plus, Minus } from "lucide-react";
import { MANIFESTO, IMAGES } from "../data/site";

export const ManifestoChapters = () => {
  const [open, setOpen] = useState(0);
  return (
    <section id="manifesto" className="py-24 sm:py-32 relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 grid lg:grid-cols-12 gap-14 items-start">
        <div className="lg:col-span-5 lg:sticky lg:top-28">
          <Reveal><span className="overline">03 — How the work unfolds</span></Reveal>
          <Reveal delay={0.05}>
            <h2 className="section-title text-3xl sm:text-4xl lg:text-5xl mt-4 leading-tight text-[#20301A]">
              Four quiet principles behind every session
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <img src={IMAGES.shadow} alt="soft botanical light" className="mt-8 rounded-3xl w-full h-64 object-cover soft-shadow border border-[#C9DFAC] hidden lg:block" />
          </Reveal>
        </div>

        <div className="lg:col-span-7">
          {MANIFESTO.map((m, i) => (
            <Reveal key={m.n} delay={i * 0.05}>
              <div className="border-b border-[#C9DFAC] py-6">
                <button data-testid={`manifesto-chapter-${m.n}`} onClick={() => setOpen(open === i ? -1 : i)}
                  className="w-full flex items-center gap-5 text-left group">
                  <span className="font-mono text-sm text-[#3A7D32]/60">{m.n}</span>
                  <span className="flex-1 font-serif text-2xl sm:text-3xl text-[#20301A] group-hover:text-[#3A7D32] transition-colors">{m.title}</span>
                  <span className="grid place-items-center w-9 h-9 rounded-full bg-[#FBEEF2] text-[#C2748C] shrink-0 border border-[#EBD4DC]">
                    {open === i ? <Minus size={16} /> : <Plus size={16} />}
                  </span>
                </button>
                <AnimatePresence initial={false}>
                  {open === i && (
                    <motion.div initial={{ height: 0, opacity: 0 }} animate={{ height: "auto", opacity: 1 }} exit={{ height: 0, opacity: 0 }}
                      transition={{ duration: 0.4, ease: [0.16, 1, 0.3, 1] }} className="overflow-hidden">
                      <p className="pt-4 pl-11 text-[#55703F] leading-relaxed max-w-xl">{m.body}</p>
                    </motion.div>
                  )}
                </AnimatePresence>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
